export default "__VITE_ASSET__BNv6_Ttq__"